import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

import {
  cellNotFilter,
  cellEstadoReporteVentaCorporativa,
  formatDate,
  cellUbicacionEvaVentaCorporativa,
} from "@/shared";
import {
  IDataPreventa,
  IDataReferido,
  IReporteVentaCorporativa,
  TiposReferidosENUM,
} from "@/shared/interfaces";
// import { useInfoCoordenadasStore } from "@/shared/components/ui/InfoCoordendas/useInfoCoordendas.store"
import { EstadoComponente } from "@/shared/components/ui";
import dayjs from "dayjs";
import { useInfoCoordenadasStore } from "@/shared/components/ui/InfoCoordendas/useInfoCoordendas.store";
import { Visibility } from "@mui/icons-material";
import { Button } from "@mui/material";
import InfoUser from "@/shared/components/ui/InfoUser/InfoUser";

export const fnReferido = (row: IDataPreventa): IDataReferido => {
  switch (row.tipo_referido) {
    case TiposReferidosENUM.FLOTA:
      return {
        contacto: row.referido_flota_data?.telefono_1!,
        identificacion: row.referido_flota_data?.numero_referencia!,
        nombre: row.referido_flota_data?.lider!,
        tipo: TiposReferidosENUM.FLOTA,
      };
    case TiposReferidosENUM.CLIENTE:
      return {
        contacto: row.referido_cliente_data?.celular!,
        identificacion: row.referido_cliente_data?.identificacion!,
        nombre: row.referido_cliente_data?.razon_social!,
        tipo: TiposReferidosENUM.CLIENTE,
      };
    default:
      return {
        contacto: "N/A",
        identificacion: "N/A",
        nombre: "N/A",
        tipo: TiposReferidosENUM.NA,
      };
  }
};

export const fnTipoContrato = (
  pre_requiere_contrato_fisico: boolean,
  requiere_contrato_fisico: boolean,
): {
  texto: string;
  color: string;
} => {
  if (requiere_contrato_fisico) {
    return {
      texto: "CONTRATO FISICO",
      color: "green",
    };
  }
  if (pre_requiere_contrato_fisico && !requiere_contrato_fisico) {
    return {
      texto: "REVISANDO SUPERVISOR",
      color: "orange",
    };
  }
  return {
    texto: "CONTRATO DIGITAL",
    color: "blue",
  };
};

export const useColumnsEstadoPreventaCorporativa = () => {
  const infoCoordendas = useInfoCoordenadasStore();
  const columnsEstadoVentaCorporativo = useMemo<
    MRT_ColumnDef<IReporteVentaCorporativa>[]
  >(
    () => [
      {
        accessorKey: "razon_social",
        header: "Razón social",
        size: 300,
        Cell: ({ row }) => row.original?.razon_social || "N/A",
      },
      {
        accessorKey: "identificacion",
        header: "Identificacion",
        Cell: ({ row }) => row.original?.identificacion || "N/A",
      },
      // {
      //   accessorKey: 'direccion_servicio',
      //   header: 'Dirección Servicio',
      //   Cell: ({ row }) => row.original?.preventa_corporativa_data?.[0]?.direccion_servicio || "N/A"
      // },
      {
        accessorKey: "nombre_plan",
        header: "Nombre Enlace",
        enableColumnFilter: false,
        Cell: ({ row }) =>
          row.original?.preventa_corporativa_data?.[0]?.data_plan_personalizado
            ?.nombre_personalizado || "N/A",
      },
      {
        accessorKey: "es_backup",
        header: "Tipo Enlace",
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={row.original?.es_backup ? "#FF9800" : "#4CAF50"}
            texto={row.original?.es_backup ? "BACKUP" : "PRINCIPAL"}
          />
        ),
      },
      {
        accessorKey: "tipo_plan",
        header: "Subtipo de Contrato",
        enableColumnFilter: false,
        Cell: ({ row }) =>
          row.original?.preventa_corporativa_data?.[0]?.tipo_plan ||
          row.original?.preventa_corporativa_data?.[0]?.data_plan_personalizado
            ?.tipo_plan_personalizado ||
          "N/A",
      },
      {
        ...cellNotFilter,
        accessorKey: "ubicacion_venta",
        header: "Ubicación Venta",
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={"blue"}
            texto={
              cellUbicacionEvaVentaCorporativa(row.original).ubicacion || ""
            }
          />
        ),
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_venta",
        header: "Proceso Actual Venta",
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={"green"}
            texto={cellEstadoReporteVentaCorporativa(row.original).modulo || ""}
          />
        ),
      },
      {
        ...cellNotFilter,
        accessorKey: "ultimo_estado",
        header: "Estado Actual Venta",
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={"blue"}
            texto={
              cellEstadoReporteVentaCorporativa(row.original).ultimo_estado ||
              ""
            }
          />
        ),
      },
      {
        ...cellNotFilter,
        accessorKey: "accion",
        header: "última acción",
        Cell: ({ row }) =>
          row.original?.trazo_corporativo_data?.[
            (row.original?.trazo_corporativo_data?.length || 1) - 1
          ]?.accion || "N/A",
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_registro",
        header: "Fecha de Registro",
        Cell: ({ row }) => (
          <EstadoComponente
            backgroundColor={"blue"}
            texto={
              dayjs(
                cellEstadoReporteVentaCorporativa(row.original).fecha_registro,
              ).format("LLL") || ""
            }
          />
        ),
      },
      {
        accessorKey: "coordenada_servicio",
        enableColumnFilter: false,
        header: "Coordenada servicio",
        Cell: ({ row }) =>
          row.original?.preventa_corporativa_data?.[0] ? (
            <Button
              endIcon={<Visibility />}
              onClick={() => {
                infoCoordendas.handlePostInfoZone(
                  {
                    latitud:
                      row.original?.preventa_corporativa_data?.[0]?.coordenada_servicio
                        .split(",")
                        .at(0)!,
                    longitud:
                      row.original?.preventa_corporativa_data?.[0]?.coordenada_servicio
                        .split(",")
                        .at(1)!,
                  },
                  row.original?.preventa_corporativa_data?.[0]?.sector ?? "0,0",
                );
              }}
            >
              {
                row.original?.preventa_corporativa_data?.[0]
                  ?.coordenada_servicio
              }
            </Button>
          ) : (
            "N/A"
          ),
      },
      {
        accessorKey: "user_create",
        header: "Asesor Venta",
        Cell: ({ row }) => <InfoUser user={row?.original?.user_create!} />,
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha Creación",
        Cell: ({ row }) => formatDate(row.original.fecha_creacion || ""),
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha Modificación",
        Cell: ({ row }) =>
          dayjs(
            row.original?.trazo_corporativo_data?.[
              (row.original?.trazo_corporativo_data?.length || 1) - 1
            ]?.fecha_modificacion,
          ).format("LLL") || "N/A",
        // Cell: ({ row }) => (
        //   formatDate(row.original.fecha_modificacion||"")
        // )
      },
      {
        accessorKey: "tag",
        header: "Etiqueta",
        size: 300,
        Cell: ({ row }) => row.original?.contrato_data?.tag || "N/A",
      },
    ],
    [],
  );

  return {
    columnsEstadoVentaCorporativo,
  };
};
